import { useMaintenanceTicketsContext } from '@/context/MaintenanceTicketsContext'
import { Box, CircularProgress } from '@mui/material'
import { FC, useEffect } from 'react'
import { PurchaseRequestData } from '../purchase-request/PurchaseRequestData'
import { PurchaseOrderData } from './PurchaseOrderData'

type Attachment = {
  id: number
  fileName: string
  presignedUrl: string
  fileType: string
  attachmentType: string
}

type PurchaseOrder = {
  purchaseOrderDtos: {
    attachments: Attachment[]
    retainAttachmentIds?: number[]
    purchaseOrderNumber: string
  }[]
  purchaseRequest: {
    attachments: Attachment[]
    retainAttachmentIds?: number[]
    purchaseRequestNumber: string
  }
}

interface PurchaseOrderFormProps {
  purchaseOrderData: PurchaseOrder[]
  setPurchaseOrderData: React.Dispatch<React.SetStateAction<PurchaseOrder[]>>
  ticketId: number
  disabled: boolean
}

export const PurchaseOrderForm: FC<PurchaseOrderFormProps> = ({
  purchaseOrderData,
  setPurchaseOrderData,
  ticketId,
  disabled,
}) => {
  const { purchaseOrderState } = useMaintenanceTicketsContext()

  // Ensure each purchase request has at least one purchase order
  useEffect(() => {
    setPurchaseOrderData((prevData) =>
      prevData.map((po) => ({
        ...po,
        purchaseOrderDtos:
          po.purchaseOrderDtos.length > 0
            ? po.purchaseOrderDtos
            : [
                {
                  purchaseOrderNumber: '',
                  attachments: [],
                },
              ],
      })),
    )
  }, [setPurchaseOrderData])

  const handleDeletePurchaseOrderDto = (
    poIndex: number,
    parentIndex: number,
  ) => {
    setPurchaseOrderData((prevData) =>
      prevData.map((po, pIndex) =>
        pIndex === parentIndex
          ? {
              ...po,
              purchaseOrderDtos: po.purchaseOrderDtos.filter(
                (_, index) => index !== poIndex,
              ),
            }
          : po,
      ),
    )
  }

  const handlePurchaseOrderDtoChange = (
    parentIndex: number,
    purchaseDataIndex: number,
    field: string,
    value: string | number,
  ) => {
    setPurchaseOrderData((prevData) =>
      prevData.map((po, pIndex) =>
        pIndex === parentIndex
          ? {
              ...po,
              purchaseOrderDtos: po.purchaseOrderDtos.map((dto, dIndex) =>
                dIndex === purchaseDataIndex
                  ? {
                      ...dto,
                      [field]: value,
                    }
                  : dto,
              ),
            }
          : po,
      ),
    )
  }

  const handleAddPurchaseOrderAttachment = (
    index: number,
    attachment: Attachment,
    parentIndex: number,
  ) => {
    setPurchaseOrderData((prevData) =>
      prevData.map((po, pIndex) =>
        pIndex === parentIndex
          ? {
              ...po,
              purchaseOrderDtos: po.purchaseOrderDtos.map((dto, dIndex) =>
                dIndex === index
                  ? {
                      ...dto,
                      attachments: [...dto.attachments, attachment],
                    }
                  : dto,
              ),
            }
          : po,
      ),
    )
  }

  const handleDeletePurchaseOrderAttachment = (
    parentIndex: number,
    dtoIndex: number,
    attachmentIndex: number,
  ) => {
    setPurchaseOrderData((prevData) =>
      prevData.map((po, pIndex) =>
        pIndex === parentIndex
          ? {
              ...po,
              purchaseOrderDtos: po.purchaseOrderDtos.map((dto, dIndex) =>
                dIndex === dtoIndex
                  ? {
                      ...dto,
                      attachments: dto.attachments.filter(
                        (_, aIndex) => aIndex !== attachmentIndex,
                      ),
                    }
                  : dto,
              ),
            }
          : po,
      ),
    )
  }

  console.log("HERE", purchaseOrderData)
  return (
    <Box>
      {purchaseOrderState.isLoading ? (
        <Box display="flex" justifyContent="center">
          <CircularProgress size={24} color="inherit" />
        </Box>
      ) : (
        <>
          {purchaseOrderData.map((data, index) => (
            <Box key={index}>
              <PurchaseRequestData
                data={data.purchaseRequest}
                onChange={() => {}}
                onDelete={() => {}}
                disabled={true}
                handleAddAttachment={() => {}}
                handleDeleteAttachment={() => {}}
                index={index}
                ticketId={ticketId}
              />
              {data.purchaseOrderDtos.map(
                (purchaseOrderData, purchaseDataIndex) => (
                  <PurchaseOrderData
                    key={purchaseDataIndex}
                    data={purchaseOrderData}
                    onChange={handlePurchaseOrderDtoChange}
                    onDelete={handleDeletePurchaseOrderDto}
                    handleAddAttachment={handleAddPurchaseOrderAttachment}
                    handleDeleteAttachment={handleDeletePurchaseOrderAttachment}
                    index={index}
                    purchaseDataIndex={purchaseDataIndex}
                    ticketId={ticketId}
                    disabled={disabled}
                  />
                ),
              )}
            </Box>
          ))}
        </>
      )}
    </Box>
  )
}
